/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Warehouse_Not_AssignableInputs */

const en_error_sales_order_warehouse_not_assignable = /** @type {(inputs: Error_Sales_Order_Warehouse_Not_AssignableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This warehouse cannot ship the order.`)
};

/**
* | output |
* | --- |
* | "This warehouse cannot ship the order." |
*
* @param {Error_Sales_Order_Warehouse_Not_AssignableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_warehouse_not_assignable = /** @type {((inputs?: Error_Sales_Order_Warehouse_Not_AssignableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Warehouse_Not_AssignableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_warehouse_not_assignable(inputs)
});